var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchFilterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140364",
    "data-name": "Rectangle 140364",
    width: 22,
    height: 22,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_19",
    "data-name": "Mask Group 19",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter",
    transform: "translate(3.605 6.687)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161319",
    "data-name": "Group 161319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83214",
    "data-name": "Path 83214",
    d: "M28.93,56.011a.616.616,0,0,1,.616-.616h3.7a.616.616,0,0,1,0,1.232h-3.7A.616.616,0,0,1,28.93,56.011Zm-2.465-3.7a.616.616,0,0,1,.616-.616h8.627a.616.616,0,1,1,0,1.232H27.081A.616.616,0,0,1,26.465,52.314ZM24,48.616A.616.616,0,0,1,24.616,48H38.174a.616.616,0,0,1,0,1.232H24.616A.616.616,0,0,1,24,48.616Z",
    transform: "translate(-24 -48)",
    fill: "#787f88"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilterIcon);
export default __webpack_public_path__ + "static/media/search-filter-icon.9ca46c32f048650e4510d6adb3ccc22a.svg";
export { ForwardRef as ReactComponent };